module.exports = __webpack_public_path__ + "static/img/126.9a845f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/126.png
// module id = VTgs
// module chunks = 0